/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Success4Inputs */

const en_coinvestments_gpestimatedticketsize_success4 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Success4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated ticket size updated successfully`)
};

/**
* | output |
* | --- |
* | "Estimated ticket size updated successfully" |
*
* @param {Coinvestments_Gpestimatedticketsize_Success4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_success4 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Success4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Success4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_success4(inputs)
});
export { coinvestments_gpestimatedticketsize_success4 as "coInvestments_gpEstimatedTicketSize_success" }